<template>
    <DataTable
        :fields="fields"
        :items="parentComponent.items"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :pagination="false"
        stacked="md"
    >
        <template #[`head(space.name)`]="{label}">
            <span class="text-link-label-1">{{ label }}</span>
        </template>
        <template #head(configuration)="{label}">
            <span class="text-link-label-1">{{ label }}</span>
        </template>
        <template #cell(configuration)="{item}">
            <div class="d-flex gap-2">
                <template v-if="item.landingPage">
                    <template v-if="item.landingPage.buybox">
                        {{ item.landingPage.buybox.name }}
                    </template>
                    <template v-else>
                        <Tooltip :text="$t('youCanChangeConfigurationInSettingsEditing')" :width="200" class="text-secondary">{{ $t('systemic') }}</Tooltip>
                    </template>
                </template>
            </div>
        </template>
        <template #cell(action)="{item}">
            <div class="d-flex flex-wrap gap-2 justify-content-end">
                <ButtonIcon size="sm" variant="success" class="wide" :to="{ name: 'ProductLandingPageGenerator', query: { space: item.space.id } }">{{ $t('generateGdzieKupicTo') }}</ButtonIcon>
                <template v-if="!item.landingPage">
                    <ButtonIcon size="sm" variant="info" class="wide" :to="{ name: 'ProductLandingPageSettingsEdit', params: { id: item.space.id } }">{{ $t('createSettings') }}</ButtonIcon>
                </template>
                <template v-else>
                    <ButtonIcon size="sm" variant="primary" class="wide" :to="{ name: 'ProductLandingPageSettingsEdit', params: { id: item.space.id } }">{{ $t('editSettings') }}</ButtonIcon>
                </template>
            </div>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import Tooltip from '@/components/common/Tooltip.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
            Tooltip,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            fields() {
                return [
                    { key: 'space.name', label: this.$t('space') },
                    { key: 'configuration', label: this.$t('widgetBuyBoxConfiguration') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
        },
    };
</script>
